
import { Component, Mixins } from 'vue-property-decorator'
import { Step } from '@/mixins/StepMixin'
import RadioGroup from '@/components/RadioGroup.vue'

@Component({
  components: {
    RadioGroup
  }
})
export default class ChooseVertical extends Mixins(Step) {
  options = this.$store.state.currentPage.selectOptions.map((option: string) => this.$t(option))
  choice = ''
  groupName = 'vertical'

  beforeMount (): void {
    if (this.$store.state.userData.vertical.choice) {
      this.choice = this.$store.state.userData.vertical.choice
      this.enableNextNavigation()
    }
  }

  updateSelected (option: string) :void {
    this.enableNextNavigation()
    this.$store.dispatch('setUserData', {
      vertical: { choice: option }
    })
  }
}
